import { useState, useEffect } from 'react';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function Dashboard() {
  const [inspectionData, setInspectionData] = useState([]);
  const [carData, setCarData] = useState({ created: [], sold: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No token found');
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const [inspectionsRes, carsRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/api/admin/inspections/stats`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_API_URL}/api/admin/cars/stats`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        setInspectionData(Array.isArray(inspectionsRes.data) ? inspectionsRes.data : []);
        setCarData({
          created: Array.isArray(carsRes.data.created) ? carsRes.data.created : [],
          sold: Array.isArray(carsRes.data.sold) ? carsRes.data.sold : [],
        });
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
        setError('Failed to load data. Check API or token.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const inspectionChartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Booked Inspections',
        data: inspectionData,
        backgroundColor: '#00FFFF',
      },
    ],
  };

  const carChartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Cars Available',
        data: carData.created,
        backgroundColor: '#FF00FF',
      },
      {
        label: 'Cars Sold',
        data: carData.sold,
        backgroundColor: '#000000',
      },
    ],
  };

  if (loading) return <div className="p-8">Loading...</div>;
  if (error) return <div className="p-8 text-red-600">{error}</div>;

  return (
    <div className="p-8 bg-white text-black font-fairplay">
      <h2 className="text-2xl font-bold mb-4">Admin Dashboard</h2>
      <div className="mb-8">
        <h3 className="text-xl font-semibold mb-2">Booked Inspections Per Month</h3>
        <Bar data={inspectionChartData} options={{ responsive: true, plugins: { legend: { position: 'top' } } }} />
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-2">Cars Created and Sold Per Month</h3>
        <Bar data={carChartData} options={{ responsive: true, plugins: { legend: { position: 'top' } } }} />
      </div>
    </div>
  );
}